import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const mixpanelDirectConnector: AvailableServiceInfo = {
  label: 'Mixpanel',
  icon: require('./mixpanel.svg'),
  isBeta: true,
  type: ConnectorType.Mixpanel,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your API Key',
      propertyName: 'api_key',
    },
  ],
  connect: (params) => params,
};
